export function scrollTo(position, callback, duration = 500) {
  $('body, html').animate({scrollTop: position}, duration, function () {
    if (callback) {
      callback();
    }
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollTo.js